import { Link, TopHat, Typography } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { $callcenterService, $userService } from "@callcenter/effector-services"
import { AuthServiceInstance } from "@callcenter/services"

import styles from "./support-warning.module.pcss"

export const SupportWarning = () => {
  const switched = useUnit($userService.$switched)
  const callcenterSettings = useUnit($callcenterService.$settings)
  const userSettings = useUnit($userService.$userSettings)

  if (!switched) {
    return null
  }

  if (switched === "callcenter") {
    return (
      <TopHat type="warning">
        <div className={styles.content}>
          <Typography.Body2 as="span" weight="bold" color="inherit">
            {callcenterSettings.name}
          </Typography.Body2>{" "}
          production environment. Any changes you make will directly affect contact center operations.
        </div>
      </TopHat>
    )
  }

  return (
    <TopHat type="warning">
      <div className={styles.container}>
        <div className={styles.content}>
          Operating as{" "}
          <Typography.Body2 as="span" weight="bold" color="inherit">
            {userSettings.name}
          </Typography.Body2>
          . Your actions will be recorded as this user in contact center events.
        </div>
        <Link onClick={() => AuthServiceInstance.logout()} className={styles.logout}>
          Stop
        </Link>
      </div>
    </TopHat>
  )
}
